import { render, staticRenderFns } from "./Aplicante.vue?vue&type=template&id=fca1dfbe&scoped=true&"
import script from "./Aplicante.vue?vue&type=script&lang=js&"
export * from "./Aplicante.vue?vue&type=script&lang=js&"
import style0 from "./Aplicante.vue?vue&type=style&index=0&id=fca1dfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca1dfbe",
  null
  
)

export default component.exports